<template>
  <div class="sticky-contact">
    <div class="contact">
      <div class="tooltip-left" @click="showModal" data-tooltip="Envoyez-nous un message">
        <img src="@/assets/img/icons.svg#icon-contact" width="30" height="21">
      </div>
      <modal-contact v-show="isModalContactVisible"
           @close="closeModal"
      />
    </div>
  </div>
</template>

<script>
  import ModalContact from "../Modal/Models/Modal-contact";
  import { mapGetters, mapActions } from "vuex"

  export default {
    name: "Contact",
    components: {
      ModalContact,
    },
    data () {
      return {
        // isModalVisible: false,
      };
    },
    computed: {
      ...mapGetters({
        isModalContactVisible: 'isModalContactVisible'
      })
    },
    methods: {
      ...mapActions({
        setModalContactVisible: 'setModalContactVisible'
      }),
      showModal() {
        this.setModalContactVisible(true);
      },
      closeModal() {
        this.setModalContactVisible(false);
      }
    },
  }
</script>

<style lang="scss">

  .sticky-contact {
    position: fixed; // for ie
    left: calc(100vw - 16%);
    position: sticky;
    float: right;
    clear: both;
    height: 0;
    top: rem(165px);
    z-index: 5;

    @include mq($until: MD) {
      top: unset;
      bottom: 15%;
      position: fixed;
      right: 0;
    }

    @include mq($from: MD, $until: LG) {
      left: calc(100vw - 10%);
    }

    .contact {
      box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.13), 0 2px 6px 0 rgba(0, 0, 0, 0.08);
      height: rem(60px);
      width: rem(60px);
      border-radius: rem(60px);
      line-height: rem(67px);
//    background: color(blue);
	  background:purple;
      cursor: pointer;
      z-index: 5;
      float: right;
      clear: both;
      margin-right:rem(-30px);

      @media screen and (max-width:1560px) {margin-right:rem(10px)}

      @include mq($until: MD) {
        border: 1px solid white;
        margin-right: rem(15px);
      }

      /**
       * Tooltip Styles
       */

      /* Base styles for the element that has a tooltip */
      [data-tooltip],
      .tooltip {
        position: relative;
        cursor: pointer;
      }

      /* Base styles for the entire tooltip */
      [data-tooltip]:before,
      [data-tooltip]:after,
      .tooltip:before,
      .tooltip:after {
        position: absolute;
        z-index: 10;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out, transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
        transform: translate3d(0, 0, 0);
        pointer-events: none;
      }

      /* Show the entire tooltip on hover and focus */
      [data-tooltip]:hover:before,
      [data-tooltip]:hover:after,
      [data-tooltip]:focus:before,
      [data-tooltip]:focus:after,
      .tooltip:hover:before,
      .tooltip:hover:after,
      .tooltip:focus:before,
      .tooltip:focus:after {
        visibility: visible;
        opacity: 1;
      }

      /* Base styles for the tooltip's directional arrow */
      .tooltip:before,
      [data-tooltip]:before {
        z-index: 1001;
        border: 6px solid transparent;
        background: transparent;
        content: "";
      }

      /* Base styles for the tooltip's content area */
      .tooltip:after,
      [data-tooltip]:after {
        z-index: 1000;
        padding: rem(15px);
        min-width: rem(250px);
        background-color: white;
        color: color(grey-dark);
        content: attr(data-tooltip);
        font-size: rem(14px);
        line-height: 1.2;
        margin-left: 0;
        margin-bottom: rem(-16px);
        box-shadow: 0 0 14px 0 rgba(0,0,0,0.2);
        border: 1px solid color(border);
        border-right: 0;
      }

      /* Directions */
      .tooltip-left:before,
      .tooltip-left:after {
        right: 100%;
        bottom: 50%;
        left: auto;
      }

      .tooltip-left:before {
        margin-left: 0;
        margin-right: rem(-12px);
        margin-bottom: 0;
        border-top-color: transparent;
        border-left-color: white;
      }

      .tooltip-left:hover:before,
      .tooltip-left:hover:after,
      .tooltip-left:focus:before,
      .tooltip-left:focus:after {
        transform: translateX(-12px);
      }
    }
  }

</style>
